module.exports = __webpack_public_path__ + "static/media/PoultryFarmSolutions.c50bb59a.svg";